import { shopScene } from '../shopkit.js';

/** 牲口市：买卖活物的地方。 */
export const petShopDoc = shopScene({
  id: 'pet_shop',
  name: '牲口市',
  shop: 'pet_shop',
  owner: '牙子',
  desc: '隔着木栅看了一圈牲口，气味不太妙。',
  w: 24, h: 18,
  floor: ':',
  counters: [{ gx: 9, gy: 3, len: 5, kind: 'pet_shop' }],
  props: [
    { type: 'stable_fence', gx: 4, gy: 10 },
    { type: 'stable_fence', gx: 5, gy: 10 },
    { type: 'feed_trough', gx: 4, gy: 12 },
    { type: 'hay_pile', gx: 17, gy: 12 },
    { type: 'animal_feed_sack', gx: 19, gy: 6 },
    { type: 'notice_board', gx: 20, gy: 14 },
  ],
  portals: [
    { to: 'fun_street', gx: 12, gy: 17, spawn: [7, 20], label: '回瓦舍街' },
  ],
});

export default petShopDoc;
